import { Stack } from '@backyard-ui/core';

import { useProductStore } from '@/presenters/store/catalog/product';

import { Item } from './Item';

export default function Medias() {
  const { medias, isExclusiveMarketPlace } = useProductStore(
    (store) => store.product
  );

  if (!medias.length && !isExclusiveMarketPlace) {
    return null;
  }

  return (
    <Stack direction="column" data-testid="stamps">
      {isExclusiveMarketPlace && (
        <Item
          type="warrant"
          title="Leroy Merlin Garante"
          link="https://www.leroymerlin.com.br/leroy-merlin-garante"
          testId="warranty-stamp"
        />
      )}

      {medias.map((media, index) => (
        <Item
          key={index}
          type={media.type}
          title={media.label}
          link={media.link}
          testId={`media-link-${index}`}
        />
      ))}
    </Stack>
  );
}
